import cn from 'classnames';
import { Fragment } from 'react';
import Button from '@components/button';
import useReduxState from '@hooks/useReduxState';
import FLOATING_ICONS from './constants';
import styles from './welcome.module.scss';
import { Link } from 'react-router-dom';

const Welcome = (): JSX.Element => {
    const [isCollapsed] = useReduxState((state) => state.chat.collapsed);

    /* ClassNames */

    const getFloatingIconClassName = (className: string) =>
        cn(className, {
            [styles.chatVisible]: !isCollapsed,
        });

    /* Components */

    const FloatingIcons: JSX.Element[] = FLOATING_ICONS.map(
        ({ icon, className }) => (
            <Fragment key={className}>
                {typeof icon === 'string' ? (
                    <img
                        src={icon}
                        alt={className}
                        className={getFloatingIconClassName(styles[className])}
                    />
                ) : (
                    <figure
                        key={className}
                        className={getFloatingIconClassName(styles[className])}
                    >
                        {icon}
                    </figure>
                )}
            </Fragment>
        ),
    );

    return (
        <section className={styles.container}>
            <div className={styles.container__welcome}>
                <h1>Welcome new Dueler!</h1>
                <p>
                    Join the Blackjack game in multiplayer mode, <br /> play
                    agaisnt others players to try your luck <br /> without the
                    dealer !
                </p>
                <Link to="/games/jackpot">
                    <Button color="green" radius="pill" size="default">
                        Play Jackpot
                    </Button>
                </Link>
            </div>

            {/* Floating Icons At The Right */}

            {FloatingIcons}
        </section>
    );
};

export default Welcome;
